import React from "react";
import styles from "./unblockUserModal.module.css";

const UnblockUserModal = ({ show, onClose, onConfirm, unblockedUsername }) => {
  if (!show) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h2>Confirmation</h2>
        <p>Are you sure you want to unblock {unblockedUsername}?</p>
        <button className={styles.unblockConfirmationBtn} onClick={onConfirm}>
          Unblock User
        </button>
        <button className={styles.cancelBtn} onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
};

export default UnblockUserModal;
